import script from "./ProfileBilling.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileBilling.vue?vue&type=script&setup=true&lang=js"

import "./ProfileBilling.vue?vue&type=style&index=0&id=258e92db&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-258e92db"]])

export default __exports__

/* vue-cli-plugin-import-components */

import ManageAccountCreditModal from "@/components/customers/ManageAccountCreditModal.vue";
import ProfileTax from "@/components/customers/profile/ProfileTax.vue";
import RecordButton from "@/components/customers/record/RecordButton.vue";
import RecordCard from "@/components/customers/record/RecordCard.vue";
import SelectInput from "@/components/neue/SelectInput.vue";
script.components = Object.assign({}, { ManageAccountCreditModal, ProfileTax, RecordButton, RecordCard, SelectInput }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { ManageAccountCreditModal, ProfileTax, RecordButton, RecordCard, SelectInput }, script.__o.components);}